export const getActualProduct = (products) => {
    let actualProduct = null;
    products === null || products === void 0 ? void 0 : products.forEach(product => {
        if (!actualProduct || (actualProduct === null || actualProduct === void 0 ? void 0 : actualProduct.id) < product.id) {
            actualProduct = product;
        }
    });
    return actualProduct;
};
export const getBaggageName = (service, count) => {
    return `${count}x ${service.name}${service.baggageWeight ? `, ${service.baggageWeight}` : ''}`;
};
export const isShowInsurancesByPassengers = (mode) => {
    return mode === 'aggregator';
};
